var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotcodeScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4329 1.36719H20.5831C21.8339 1.36719 22.8478 2.38114 22.8478 3.63191V7.70674",
    stroke: "white",
    strokeWidth: 1.13236,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.755 1.34668H3.60476C2.35399 1.34668 1.34004 2.36063 1.34004 3.6114V7.68623",
    stroke: "white",
    strokeWidth: 1.13236,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76794 22.8408H3.6177C2.36693 22.8408 1.35298 21.8269 1.35298 20.5761V16.5013",
    stroke: "white",
    strokeWidth: 1.13236,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4329 22.8408H20.5831C21.8339 22.8408 22.8478 21.8269 22.8478 20.5761V16.5013",
    stroke: "white",
    strokeWidth: 1.13236,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55237 5.7168V12.2718",
    stroke: "white",
    strokeWidth: 1.36152,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.637 5.7168V12.2718",
    stroke: "white",
    strokeWidth: 1.36152,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9894 5.7168L14.9894 9.56557",
    stroke: "white",
    strokeWidth: 1.36152,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54834 5.7168L9.54834 17.8889",
    stroke: "white",
    strokeWidth: 1.36152,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55237 15.5566L5.55237 18.2854",
    stroke: "white",
    strokeWidth: 1.45229,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.637 15.5146L18.637 18.2859",
    stroke: "white",
    strokeWidth: 1.36152,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.8717,
    y: 11.748,
    width: 6.70485,
    height: 7.06044,
    rx: 1.00587,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotcodeScan);
export default __webpack_public_path__ + "static/media/dotcodeScan.6fc74c5797e958122f106c96a9507248.svg";
export { ForwardRef as ReactComponent };